module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-38.8997ef8d.png";